module.exports = __webpack_public_path__ + "img/pr-4.7aeef245.png";